import styled from 'styled-components';
import {Pagination} from 'react-bootstrap';


const StyledPagination = styled(Pagination)`
    font-size:16px;
    border-radius: 6px;    
    &.pagination li > a:hover, &.pagination li > a:focus, &.pagination li > span:hover, &.pagination li > span:focus {
           background-color: ${props => props.theme.hoverColor};
    }
    .active.active > a, .active.active > a:hover, .active.active > a:focus, .active.active > span, .active.active > span:hover, .active.active > span:focus {
       background-color: ${props => props.theme.brandColor};
       border-color: ${props => props.theme.brandColor};
    }        
`;

export default StyledPagination;


// WEBPACK FOOTER //
// ./components/utils/Styled/pagination.js